import { render, staticRenderFns } from "./relativesAndAssociates.vue?vue&type=template&id=c2e80f30"
import script from "./relativesAndAssociates.vue?vue&type=script&lang=js"
export * from "./relativesAndAssociates.vue?vue&type=script&lang=js"
import style0 from "./relativesAndAssociates.vue?vue&type=style&index=0&id=c2e80f30&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports